export class DropdownConfiguration {
    public id: number;
    public name: string;
    public key: string;
    public dropdowns = [];
}
